module.exports = __webpack_public_path__ + "14af2f7279e35174af608eb65ab0ea1f.png";